import { Component, Input, OnInit } from '@angular/core';
import { Terminal } from 'src/app/@core/domain/interfaces/terminal.interface';
import { NbDialogService } from '@nebular/theme';
import { TerminalActionsDialogComponent } from '../terminal-actions-dialog/terminal-actions-dialog.component';
import { LogService } from '../../../../../@core';

@Component({
  selector: 'app-terminal',
  templateUrl: './terminal.component.html',
  styleUrls: ['./terminal.component.scss'],
})
export class TerminalComponent implements OnInit {
  @Input()
  terminal: Terminal | undefined;
  terminalTypeIcon = 'terminalType_0';
  iconColor = '';

  constructor(private dialogService: NbDialogService, private logger: LogService) {}

  ngOnInit(): void {
    if (this.terminal) {
      const terminalTypeEnumValue = Object.values(this.terminal.type)[0];
      this.terminalTypeIcon = 'terminalType_' + terminalTypeEnumValue;
      if (this.terminal.status.color === 0) {
        this.iconColor = 'red';
      }
      if (this.terminal.status.color === 1) {
        this.iconColor = 'green';
      }
      if (this.terminal.status.color === 2) {
        this.iconColor = 'grey';
      }
    }
  }

  openModal() {
    this.logger.info('Open terminal actions dialog');
    this.dialogService.open(TerminalActionsDialogComponent, {
      closeOnBackdropClick: true,
      closeOnEsc: true,
      hasBackdrop: true,
      context: {
        terminal: this.terminal,
      },
    });
  }
}
